import { useLocation, useNavigate } from "react-router";
import { Button } from "@/components/Button";
import livlyLogo from "../assets/livly_logo-text.svg";
import { User } from "@/types/User";
import { buildRedirectPath } from "./login/callback";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = (location.state as { user: User | null } | null) || {
    user: null,
  };

  const redirectPath = buildRedirectPath(user, []);

  return (
    <div className="h-screen flex flex-col justify-center items-center">
      <img src={livlyLogo} alt="Livly" className="h-8" />
      <div className="text-[#565553] text-2xl mt-6">Resource not found</div>
      <Button
        className="mt-12"
        onClick={() => navigate(redirectPath, { replace: true })}
      >
        Home
      </Button>
    </div>
  );
}
